module.exports = __webpack_public_path__ + "img/fashion_36.aea93aa9.jpg";